"use no memo";

import React, { useEffect, useRef } from 'react';

import styles from './styles.module.scss';

function SkipLink() {
  const skipLinkRef = useRef<HTMLAnchorElement>(null);

  useEffect(() => {
    function handleKeyDown(e: KeyboardEvent) {
      if (e.key !== 'Tab' || e.shiftKey) return;

      const root = document.getElementById('root');
      const modalRoot = document.getElementById('modal-root');
      const activeEl = document.activeElement;
      const isInModal =
        !!activeEl?.closest('[role="dialog"]') ||
        !!modalRoot?.contains(activeEl);

      if (!root?.contains(activeEl) && !isInModal) {
        e.preventDefault();
        skipLinkRef.current?.focus();
      }
    }

    document.addEventListener('keydown', handleKeyDown);
    return () => document.removeEventListener('keydown', handleKeyDown);
  }, []);

  function focusTarget(
    id: string,
    block: ScrollLogicalPosition = 'center'
  ): boolean {
    const el = document.getElementById(id);
    if (el) {
      el.focus();
      if (document.activeElement === el) {
        el.scrollIntoView({ block });
        return true;
      }
    }
    return false;
  }

  function skipToContent() {
    const _ =
      focusTarget('skip-link-target') ||
      focusTarget('more-info-link') ||
      focusTarget('main-content', 'start');
    skipLinkRef.current?.blur();
  }

  function handleClick(e: React.MouseEvent<HTMLAnchorElement>) {
    e.preventDefault();
    skipToContent();
  }

  function handleSkipKeyDown(e: React.KeyboardEvent<HTMLAnchorElement>) {
    if (e.key === 'Enter') {
      e.preventDefault();
      skipToContent();
    }
  }

  return (
    <a
      ref={skipLinkRef}
      href="#main-content"
      className={styles.skipLink}
      onClick={handleClick}
      onKeyDown={handleSkipKeyDown}
    >
      Skip to main content
    </a>
  );
}

export default SkipLink;
